import { useState } from "react";
import { api, IDR } from "@/lib/api";

export default function Track() {
  const [form, setForm] = useState({ order_number: "", contact: "" });
  const [order, setOrder] = useState(null);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setOrder(null);
    try {
      const { data } = await api.post("/orders/track", form);
      setOrder(data);
    } catch (e) { setErr(e?.response?.data?.detail || "Gagal"); }
  };

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-8 py-16">
      <h1 className="display text-5xl md:text-7xl">LACAK PESANAN</h1>
      <p className="text-neutral-400 text-sm mt-2">Masukkan nomor order dan email/telepon yang kamu gunakan saat checkout.</p>
      <form onSubmit={submit} className="mt-8 space-y-4">
        <input data-testid="track-order-input" required placeholder="Nomor Order (mis. TS-260901-XXXX)" className="w-full bg-transparent border border-[color:var(--border)] p-3 focus:border-white outline-none"
          value={form.order_number} onChange={(e) => setForm({ ...form, order_number: e.target.value })} />
        <input data-testid="track-contact-input" required placeholder="Email atau nomor telepon" className="w-full bg-transparent border border-[color:var(--border)] p-3 focus:border-white outline-none"
          value={form.contact} onChange={(e) => setForm({ ...form, contact: e.target.value })} />
        <button data-testid="track-submit" className="w-full bg-white text-black py-3 text-xs tracking-widest">CEK STATUS</button>
      </form>
      {err && <div className="mt-6 text-[color:var(--accent)] text-sm">{err}</div>}
      {order && (
        <div className="mt-8 border border-[color:var(--border)] p-6 space-y-3 fade-in-up">
          <div className="display text-3xl">{order.order_number}</div>
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div><div className="text-[10px] text-neutral-500 tracking-widest">PEMBAYARAN</div>{order.payment_status}</div>
            <div><div className="text-[10px] text-neutral-500 tracking-widest">ORDER</div>{order.order_status}</div>
            <div><div className="text-[10px] text-neutral-500 tracking-widest">PRODUKSI</div>{order.production_status}</div>
            <div><div className="text-[10px] text-neutral-500 tracking-widest">PENGIRIMAN</div>{order.shipping_status}</div>
          </div>
          <div className="border-t border-[color:var(--border)] pt-3">
            {order.items.map((it, i) => (
              <div key={i} className="flex justify-between text-sm py-1">
                <span>{it.article_code} · {it.name} · {it.color}/{it.size} × {it.qty}</span>
                <span className="tabular-nums">{IDR(it.line_total)}</span>
              </div>
            ))}
          </div>
          <div className="flex justify-between display text-2xl"><span>TOTAL</span><span>{IDR(order.total)}</span></div>
        </div>
      )}
    </div>
  );
}
